import { Field } from 'react-final-form';
import { ColorFieldHelp } from './ColorFieldHelp';
import { DEFAULT_COLORS } from './constants';
import { FullPaletteField } from './FullPalette';

export const ColorFieldInput = ({ field }: { field: FullPaletteField }) => {
  const hasDescription = field.description != null && field.description !== '';

  return (
    <Field name={field.name} allowNull>
      {({ input, meta }) => (
        <div className="col-md-4 padding0">
          <label htmlFor={`${field.name}-input`}>
            {field.label}
            {hasDescription && field.description != null && (
              <ColorFieldHelp description={field.description} />
            )}
          </label>
          <input
            id={`${field.name}-input`}
            name={`${field.name}-input`}
            type="color"
            className="input-color-full"
            value={!input.value ? DEFAULT_COLORS[field.name] : input.value}
            onChange={e => input.onChange(e.target.value)}
          />
          {meta.error && meta.touched && (
            <label htmlFor={`${field.name}-input`} className="error">
              {meta.error}
            </label>
          )}
        </div>
      )}
    </Field>
  );
};
